import { tryParseJSONObject } from '@fox/atoms';
import { TicketAnswer } from '../../ticket-block/contracts';
import { QuestionValidator } from '../util/allow-next';

/**
 * Used for validating the ticket block when marked as required
 * @param answer - Form ticket answer
 * @returns True if required answers length match
 */
export const ticketRequirementsValidator: QuestionValidator = (answer, _, waitlistSubmit) => {
	if (!answer) {
		return !!waitlistSubmit;
	}

	const TICKET_BLOCK_NO_OF_REQUIRED_ANSWERS = 2;
	const parsedAnswer = tryParseJSONObject<TicketAnswer>(answer?.answer?.answerJson, {});
	const numberOfAnswers = Object.keys(parsedAnswer).length;
	return Boolean(TICKET_BLOCK_NO_OF_REQUIRED_ANSWERS === numberOfAnswers && (parsedAnswer?.quantity ?? 0) > 0 && !!parsedAnswer?.ticketId);
};
